// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2dC7c","footer":"ModalError_footer__1uEsZ"};